export default "images/FitChicks-Title-500.png";